// Formateo de importes de créditos. Los Decimal del backend pueden llegar como
// string o number según el serializador: normalizamos con Number(x) y, si no es
// numérico, devolvemos el valor tal cual para no ocultar datos.

export const formatCredits = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '0.00';
  const num = Number(value);
  return Number.isNaN(num) ? String(value) : num.toFixed(2);
};

// Primer valor definido y no-null de una lista de candidatos (para respuestas
// del backend en construcción donde el nombre exacto del campo puede variar).
export const firstDefined = <T,>(...values: (T | null | undefined)[]): T | null => {
  for (const v of values) {
    if (v !== null && v !== undefined) return v;
  }
  return null;
};
